<div class="divider">
  <div class="line"></div>
  <div>
    <ng-content></ng-content>
  </div>
  <div class="line"></div>
</div>
